import { checkWithinSeCe } from 'components/ProtectedRoute/utils';
import * as Sentry from '@sentry/react';
import { backendHost, LEAD_TRACKING_URL } from 'utils/constants';
import { getUTMData } from './cookies';
import { LeadTraits, LeadTraitsBase } from '../types';

export const cTrackingListener = () => {
  if (checkWithinSeCe()) return; // NEVER use 3P scripts within SeCe.

  const capterraVkey = '1150b5fd130ced0149065a26555d213a';
  const capterraVid = '2096571';
  const ct = document.createElement('img');
  ct.src = `https://ct.capterra.com/capterra_tracker.gif?vid=${capterraVid}&vkey=${capterraVkey}`;
  document.body.appendChild(ct);
};

/**
 * Send lead data to Pensieve via monolith endpoint.
 * Required fields (enforced by BE controller): firstName, lastName, email, country.
 * If any required field is missing, the call is skipped.
 *
 * Optional fields: phone, adobeECID, signup_waiting_list, marketingConsent, utm_* params.
 */
export async function trackLeadToPensieve(traits: LeadTraits): Promise<void> {
  if (!traits.email || !traits.country || !traits.firstName || !traits.lastName) {
    return;
  }

  const payload = {
    firstName: traits.firstName,
    lastName: traits.lastName,
    email: traits.email,
    country: traits.country,
    ...(traits.phone && { phone: traits.phone }),
    ...('utm_referrer' in traits && traits.utm_referrer && { referrer: traits.utm_referrer }),
    ...(traits.adobeECID && { ecid: traits.adobeECID }),
    ...(traits.signup_waiting_list && { signup_waiting_list: traits.signup_waiting_list }),
    ...(traits.marketingConsent != null && { marketing_consent: traits.marketingConsent }),
    ...Object.keys(traits)
      .filter((key) => key.startsWith('utm_'))
      .reduce((acc, key) => ({ ...acc, [key]: traits[key as keyof LeadTraits] }), {}),
  };

  try {
    await fetch(`${backendHost}${LEAD_TRACKING_URL}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    Sentry.captureException(error, {
      tags: { context: 'pensieve_lead_tracking' },
      extra: { email: traits.email },
    });
  }
}

export const addUTMData = (baseData: LeadTraitsBase) => {
  const UTMData = getUTMData(); // exports needed to allow mocking
  return { ...baseData, ...UTMData };
};
